<template>
  <div id="SWSHeader">
    <el-row type="flex" justify="space-between" align="middle"
            style="background-image: linear-gradient(to right, #F8FFFF, #64B0B2, #78B3C4); height: 52px">
      <el-col style="display: flex; align-items: center;height:64px;">
          <el-image style="margin-left:5px;" :src="require('@/assets/image/LOGO_xinfu.svg')"/>
          <span style="margin-left:10px;font-size:25px;font-weight:bold;">信服集团管理系统</span>
      </el-col>
      <el-col style="display: flex;justify-content: flex-end;align-items: center" :span="7" v-if="showPersonInfo">
        <expire-info-tray v-if="!dialogVisible"/>
        <div>
          <span style="color:white;display:inline-block;text-overflow: ellipsis;white-space: nowrap;">{{ userName }}&nbsp;</span>
        </div>
        <el-popover
          placement="bottom-end"
          ref="loginInfo"
          effect="dark"
          trigger="hover">
          <div class="header-info">
            <el-row>
              <el-col :span="6" style="text-align: right;">
                <label for="header-info-user"><span>姓名:</span></label>
              </el-col>
              <el-col :offset="1" :span="15" style="display:block;font-size: 14px;">
                <span id="header-info-user">{{ userName }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" style="display:block;text-align: right;">
                <label for="header-info-role" style="text-align: right;"><span>担当组织:</span></label>
              </el-col>
              <el-col :offset="1" :span="15" style="font-size: 14px;">
                <span id="header-info-role" v-html="showOrgInfo()"/>
              </el-col>
            </el-row>
            <el-row style="margin-bottom:5px;margin-top:5px;margin-left:20px;margin-right:20px;border-bottom: 1.5pt solid #ACACAC;"/>
            <el-dropdown-item @click.native="updUsrPwd" style="margin-top:10px;margin-left:20px;margin-right:20px;">
              <span style="display:block;text-align: right;line-height:25px;">修改密码</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="handleLogout" style="margin-bottom:10px;margin-left:20px;margin-right:20px;">
              <span style="display:block;text-align: right;line-height:25px;">退出</span>
            </el-dropdown-item>
          </div>
        </el-popover>
        <el-avatar v-popover:loginInfo icon="el-icon-user-solid"/>
      </el-col>
    </el-row>
    <el-dialog width="600px" title="修改密码" destroy-on-close
    	:close-on-click-modal="false" @close="closeDialog"
    	:visible.sync="dialogVisible" :append-to-body="true">
      <template #default>
        <login-user-password-modifier :dialogVisible.sync="dialogVisible"/>
      </template>
      <template #footer/>
    </el-dialog>
  </div>
</template>

<script>
import ExpireInfoTray from '@/components/common/ExpireInfoTray'
import LoginUserPasswordModifier from "@/components/common/LoginUserPasswordModifier";
export default {
  name: 'SWSHeader',
  props: {
    showPersonInfo: {
      default: true,
      type: Boolean
    }
  },
  inject: ['reload'],
  data() {
    return {
      userName: this.$store.state.loginUser.usr.usrNm,
      dialogVisible: this.$store.state.loginUser.usr.initFg == 1
    }
  },
  components: {
    ExpireInfoTray,
    LoginUserPasswordModifier
  },
  methods: {
    showOrgInfo() {
      let retStr = ''
      this.$store.state.loginUser.usrOrgList.forEach(x => {
        let settleNm = '个人结算'
        if (x.orgCd != 'ORG001') {
          if (retStr !== '') {
            retStr = retStr + '<br/>'
          }
          if (x.settleType == '20') {
            settleNm = '项目结算'
          }
          retStr = retStr + x.orgNm + '(' + x.jobOfferNm + ')' + ' ' + settleNm;
        }
      })
      return retStr
    },
    updUsrPwd() {
      this.dialogVisible = true
    },
    async logout() {
      await this.$store.dispatch('logout')
      await this.$router.push('/login')
    },
    closeDialog() {
      if (this.$store.state.loginUser.usr.initFg == 1) {
        this.logout()
      }
      this.dialogVisible = false
    },
    handleLogout() {
      this.$confirm('确定要退出吗？', '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        cancelButtonClass: 'common-clear-button',
        confirmButtonClass: 'common-button',
        closeOnClickModal: false
      }).then(() => {
        this.axios.post('logout').then(response => {
          this.$store.dispatch('logout')
          this.$router.push({name: 'login'})
        })
      }).catch((e) => {
        return true
      })
    }
  }
}
</script>

<style scoped>
.header-info {
  width: 450px;
  float: right;
  margin-right: 20px;
  font-size: 14px;
  color: black;
  line-height: 24px;
  display: inline-block;
}

.el-menu--horizontal > .el-menu-item.is-active {
  color: white;
}

.top-navigation-menu.el-menu.el-menu--horizontal {
  height: 80px;
  border-bottom: 0;
}

.el-menu--horizontal .el-menu .el-menu-item.is-active {
  font-weight: bold;
  background: #3a8ee6;
  border-bottom-color: orange;
}

.el-menu--horizontal .el-menu.el-menu--popup .el-menu-item {
  width: 100%;
}

.el-menu--horizontal .el-menu.el-menu--popup .el-menu-item:hover {
  background: #ecf5ff;
}

.el-menu--horizontal .el-menu.el-menu--popup .el-menu-item.is-active {
  background: #ecf5ff;
  font-weight: normal;
  color: #409eff !important;
}

.bpo-icon:after {
  content: '信服集团管理系统';
  font-style: normal;
  font-weight: bold;
  line-height: 50px;
  font-size: 30px;
  color: rgb(89,89,89);
}

.alert-icon {
  font-size: 35px;
  color: #3a8ee6;
  transition: 0.3s;
}

.alert-icon:hover {
  opacity: .8;
}

.alert-icon-tray {
  margin-right: 35px;
  overflow: visible;
  height: 40px;
  display: inline-block;
}

.alert-icon-tray .el-badge {
  margin-top: 4px;
}

.el-avatar {
  float: right;
  margin-right: 10px;
  background: #3a8ee6;
  width: 35px;
  height: 35px;
  margin-top: 2px;
  transition: 0.3s;
}

.el-avatar:hover {
  opacity: .8;
}

.el-avatar--icon {
  font-size: 24px;
  color: white;
}
</style>

<style>
.el-badge sup.el-badge__content.is-fixed {
  top: 5px;
  right: 16px;
}
</style>
